import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IAtvApiConfig } from '../../api/atv/atvApi.types';

interface IYodleeConfigState {
  fastLinkURL: string;
  accessToken: string;
  providerAccountID: string;
  error?: Error | null;
  YodleeUrl: string;
  configName: string;
  obAppName: string;
  uuid: string;
}

const initialState: IYodleeConfigState = {
  fastLinkURL: '',
  accessToken: '',
  providerAccountID: '',
  YodleeUrl: 'https://cdn.yodlee.com/fastlink/v4/initialize.js',
  configName: '',
  obAppName: '',
  uuid: '',
};

export const yodleeConfigSlice = createSlice({
  name: 'yodleeConfig',
  initialState,
  reducers: {
    setYodleeConfig: (state, action: PayloadAction<IAtvApiConfig>) => {
      state.fastLinkURL = action.payload.fastLinkUrl;
      state.accessToken = action.payload.token;
      state.configName = action.payload.configName;
      state.obAppName = action.payload.obAppName;
      state.uuid = action.payload.id;
    },
    setProviderAccountID: (state, action: PayloadAction<string>) => {
      state.providerAccountID = action.payload;
    },
    setError: (state, action: PayloadAction<Error | null>) => {
      state.error = action.payload;
    },
  },
});

export const { setYodleeConfig, setProviderAccountID, setError } =
  yodleeConfigSlice.actions;
export default yodleeConfigSlice.reducer;
